import ClipBody from '../modules/ClipBody.js';

const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const navMobile = document.getElementById('c-nav-mobile');
const html = document.documentElement;

document.addEventListener('click', (e) => {
  if (!e.target.closest('.js-nav-toggle-mobile')) return;
  ClipBody.toggle(navMobile);
  html.classList.toggle('js-mobile-nav');
});

window.addEventListener('resize', debounce(() => {
  if (navMobile && window.getComputedStyle(navMobile).display === 'none') {
    html.classList.remove('js-mobile-nav');
  }
}, 250));
